namespace GeniuzPOS.ReportMasterData {
    export interface Report_1320Form {
    }

    export class Report_1320Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1320';
    }
}
